import { StateSchema } from '@/hooks/form/models'
import {
  BonusProvider,
  SportRestrictionObject,
} from '@/state/bonus-engine/models'
import { BonusType } from '@/enums'

import CasinoRestrictionsComponent from './casino-restrictions/index.component'
import SportRestrictions from './sports-restrictions/index.component'

type Props = {
  handleOnChange: (name: string, value: any) => void
  handleOnClickSetEnable: (
    type: string,
    value: number | string,
    all?: boolean,
  ) => void
  handleOnClickSetDisable: (
    type: string,
    value: number | string,
    all?: boolean,
  ) => void
  handleOnClickSetDiscardContribution: (
    type: string,
    value: number | string,
  ) => void
  getProductsInitValues: () => SportRestrictionObject[]
  getWagerTypeInitValues: (hideElement?: boolean) => SportRestrictionObject[]
  getSportInitValues: (hideElement?: boolean) => SportRestrictionObject[]
  handleOnChangeProvider: (name: string, value: any) => void
  bonusType: string
  state: StateSchema
  providers: BonusProvider[]
}

const RestrictionsComponent = ({
  handleOnChange,
  handleOnChangeProvider,
  handleOnClickSetDisable,
  handleOnClickSetDiscardContribution,
  handleOnClickSetEnable,
  getProductsInitValues,
  getSportInitValues,
  getWagerTypeInitValues,
  bonusType,
  state,
  providers,
}: Props) => {
  return (
    <>
      {bonusType === BonusType.CASINO_STANDARD ||
      bonusType === BonusType.BETSOFT_CASINO ||
      bonusType === BonusType.FREE_SPINS ? (
        <CasinoRestrictionsComponent
          handleOnChange={handleOnChange}
          handleOnChangeProvider={handleOnChangeProvider}
          state={state}
          providers={providers}
          bonusType={bonusType}
        />
      ) : (
        <SportRestrictions
          handleOnChange={handleOnChange}
          state={state}
          handleOnClickSetDisable={handleOnClickSetDisable}
          handleOnClickSetEnable={handleOnClickSetEnable}
          handleOnClickSetDiscardContribution={
            handleOnClickSetDiscardContribution
          }
          getProductsInitValues={getProductsInitValues}
          getSportInitValues={getSportInitValues}
          getWagerTypeInitValues={getWagerTypeInitValues}
          bonusType={bonusType}
          rolloverRestrictions={false}
          hideTypes={true} // Hide Some Types On Free Play Restrictions
          title="bonusStepRestrictions"
        />
      )}
    </>
  )
}

export default RestrictionsComponent
